import { saveAvailability } from './ajax.js';

// Shared day mapping used across the module
const DAY_MAPPING = {
	monday: 'Mon',
	tuesday: 'Tue',
	wednesday: 'Wed',
	thursday: 'Thu',
	friday: 'Fri',
	saturday: 'Sat',
	sunday: 'Sun',
};

const FULL_DAYS = Object.keys(DAY_MAPPING);

const DEFAULT_START = '09:00';
const DEFAULT_END = '17:00';

function getDayElements(fullDay) {
	const toggle = document.getElementById('toggle-' + fullDay);
	const timeRow = document.getElementById('time-row-' + fullDay);

	const startInput = document.querySelector(
		`input[name="availability[${fullDay}][start]"]`,
	);
	const endInput = document.querySelector(
		`input[name="availability[${fullDay}][end]"]`,
	);

	return { toggle, timeRow, startInput, endInput };
}

function setTimeRowEnabled(timeRow, enabled) {
	if (!timeRow) return;
	if (enabled) {
		timeRow.classList.remove('opacity-50', 'pointer-events-none');
	} else {
		timeRow.classList.add('opacity-50', 'pointer-events-none');
	}
}

function showAlert(type, message) {
	window.wpcore?.alert?.(type, 'Update Availability', message);
}

export function initAvailabilitySettings() {
	const toggles = document.querySelectorAll(
		'input[type="checkbox"][id^="toggle-"]',
	);
	const form = document.getElementById('availability-form');

	if (!toggles.length || !form) return;

	// Store initial form state
	const initialState = captureFormState();

	// Toggle enable/disable UI for time inputs
	toggles.forEach((toggleEl) => {
		toggleEl.addEventListener('change', function () {
			const fullDay = this.id.replace('toggle-', '');
			const { timeRow } = getDayElements(fullDay);
			setTimeRowEnabled(timeRow, this.checked);
		});
	});

	// Handle form submission
	form.addEventListener('submit', async (e) => {
		e.preventDefault();

		const submitBtn = document.getElementById('save-availability-btn');
		if (!submitBtn) return;

		// Disable button and show loading state
		submitBtn.disabled = true;
		submitBtn.textContent = wpcore.direct_t({ en: 'Saving...', fr: 'Enregistrement...' });
		// Collect form data
		const availabilityData = [];

		for (const [fullDay, shortDay] of Object.entries(DAY_MAPPING)) {
			const { toggle, startInput, endInput } = getDayElements(fullDay);

			availabilityData.push({
				day: shortDay,
				enabled: !!toggle?.checked,
				start_time: startInput?.value ?? DEFAULT_START,
				end_time: endInput?.value ?? DEFAULT_END,
			});
		}

		// Send AJAX request
		const result = await saveAvailability(form, availabilityData);
		showAlert(result.success ? 'success' : 'error', result.message);

		submitBtn.disabled = false;
		submitBtn.textContent = wpcore.direct_t({ en: 'Save', fr: 'Enregistrer' });
	});

	// Handle cancel button
	const cancelBtn = document.getElementById('cancel-availability-btn');
	if (cancelBtn) {
		cancelBtn.addEventListener('click', () => {
			restoreFormState(initialState);
		});
	}
}

// Capture current form state
function captureFormState() {
	const state = {};

	for (const fullDay of FULL_DAYS) {
		const { toggle, startInput, endInput } = getDayElements(fullDay);

		state[fullDay] = {
			enabled: !!toggle?.checked,
			start: startInput?.value ?? DEFAULT_START,
			end: endInput?.value ?? DEFAULT_END,
		};
	}

	return state;
}

// Restore form to previous state
function restoreFormState(state) {
	for (const fullDay of FULL_DAYS) {
		const { toggle, timeRow, startInput, endInput } = getDayElements(fullDay);
		const prev = state?.[fullDay];

		if (toggle) {
			toggle.checked = !!prev?.enabled;
			setTimeRowEnabled(timeRow, toggle.checked);
		}

		if (startInput) startInput.value = prev?.start ?? DEFAULT_START;
		if (endInput) endInput.value = prev?.end ?? DEFAULT_END;
	}
}
